import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "../ui/button"

const MarketingBanner = () => {
  const navigate = useNavigate()
  const handleRegisterClick = () => {
    navigate("/5daybusinessbootcamp")
  }

  return (
    <section
      className="relative py-4 px-4 flex justify-center text-center"
      style={{
        background: "linear-gradient(90deg, #FFEC8E 0%, #C47070 100%)",
      }}
    >
      <div className="flex flex-wrap items-center justify-center gap-3 leading-snug max-w-[1100px]">
        <span className="italic">
          Register now for the{" "}
          <span className="font-bold">January 2026 Business Bootcamp</span> ,
          NBHWC and ICF Accredited!
        </span>
        <Button variant="black" className="" onClick={handleRegisterClick}>
          LEARN MORE
        </Button>
      </div>
    </section>
  )
}

export default MarketingBanner
